// src/pages/Chatbot/ChatbotScripts.js
import React, { useState, useEffect } from "react";
import { ChatScriptsURL } from "../../config";
import backendURL from "../../config";
import { CHATBOT_UI } from "../../config";
import axios from "axios";
import { useChatbots } from "../../contexts/ChatbotContext"; // 1. Import the context hook

export default function ChatbotScripts() {
   const { activeChatbot } = useChatbots(); // 2. Get the active chatbot from context
   const [error, setError] = useState(null);
   const [scriptFilename, setScriptFilename] = useState("");
   const [scriptData, setScriptData] = useState(null);
   const [loading, setLoading] = useState(true);

   // 3. This effect now re-runs whenever the activeChatbot changes
   useEffect(() => {
      // Only fetch data if there is an active chatbot
      if (activeChatbot) {
         fetchData();
      }
   }, [activeChatbot]);

   const fetchData = async () => {
      if (!activeChatbot) {
         setLoading(false);
         setError("No active chatbot selected.");
         return;
      }
      
      setLoading(true);
      setError(null);
      setScriptData(null); // Clear previous data

      try {
         const token = localStorage.getItem('access_token');
         const headers = { Authorization: `Bearer ${token}` };
         
         // 4. Pass the active chatbot's ID as a query parameter
         const params = { chatbot_id: activeChatbot.id };

         // Make the API request with the specific chatbot_id
         const response = await axios.post(`${backendURL}/get-javascript`, {}, { headers, params });
         const responseData = response.data.data; // Data is now a direct object

         if (Object.keys(responseData).length > 0) {
            setScriptData(responseData);
         }
      } catch (error) {
         console.error("Full error details:", error);
         if (error.response) {
            setError(`Error fetching script: ${error.response.data.message || error.response.statusText}`);
         } else if (error.request) {
            setError("No response received from the server. Please try again.");
         } else {
            setError(`Error setting up request: ${error.message}`);
         }
      } finally {
         setLoading(false);
      }
   };

   useEffect(() => {
      if (scriptData && scriptData.chatbot_identity) {
        const dynamicScript = `<!-- Add in the <head> section -->
<script src="${ChatScriptsURL}/embed/klonit-chatbot.js"></script>
<script>
   function initializeChatbot() {
      if (window.KloneIT && typeof window.KloneIT.init === 'function') {
         const config = {CHATBOT_ID: '${scriptData.chatbot_identity}'};
         window.KloneIT.init(config);
      } else {setTimeout(initializeChatbot, 100);}}
   if (document.readyState === 'loading') {document.addEventListener('DOMContentLoaded', initializeChatbot); } else {initializeChatbot();}
</script>`;
         setScriptFilename(dynamicScript);
      } else {
         setScriptFilename(""); // Clear script if no data
      }
   }, [scriptData]);

   const handleCopyClick = () => {
      navigator.clipboard.writeText(scriptFilename)
         .then(() => alert("Script copied to clipboard!"))
         .catch((err) => console.error("Copy failed", err));
   };

   const chatbotLink = scriptData ? `${CHATBOT_UI}/?CHATBOT_ID=${scriptData.chatbot_identity}` : "#";

   if (loading) {
      return (
         <div className="card">
            <div className="card-body text-center">
               <p>Loading script...</p>
            </div>
         </div>
      );
   }

   return (
      <div>
         <div className="container-fluid p-0">              
            <div className="row">
               <div className="col-md-12">
                  <h4>Script for {activeChatbot?.chatbot_name || '...'}</h4>
                  <div className="card">
                     <div className="card-body">
                        <div className="form-group">
                           <textarea 
                              className="form-control" 
                              value={scriptFilename} 
                              readOnly 
                              rows="12"
                              placeholder="Select a chatbot to generate its script."
                           />
                           <button 
                              className="btn btn-secondary mt-2" 
                              onClick={handleCopyClick}
                              disabled={!scriptFilename}
                           >
                              <i className="fa fa-copy"></i> Copy
                           </button>
                           <a href={chatbotLink} className="btn btn-secondary mt-2 mx-2" target="_blank" rel="noopener noreferrer">Open Chatbot</a>
                           <a href="wordpress-plugin" className="btn btn-secondary mt-2 mx-2">Download Wordpress Plugin</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {error && <div className={`alert alert-warning mt-3`}>{error}</div>}
         </div>
      </div>
   );
}